import CommonConstant from "../constants/common.constant";
import moment from "moment";
import "moment-timezone";

const ConsoleLog = (message: any, data?: string) => {
  if (`${process.env.ENVIRONMENT}` === CommonConstant.localEnvironemt) {
    if (data) console.log(message, data);
    else console.log(message, data);
  }
};

const ConsoleLogError = (message: any, data?: string) => {
  if (`${process.env.ENVIRONMENT}` === CommonConstant.localEnvironemt) {
    if (data) console.error(message, data);
    else console.error(message, data);
  }
};

const ConvertUtcToLocalReadable = (UTC_FormatDate: any) => {
  let date = new Date(UTC_FormatDate);
  const month = date.toLocaleString("default", { month: "short" });
  const day = date.toLocaleDateString("default", {
    // you can use undefined as first argument
    day: "2-digit",
  });
  const year = date.toLocaleDateString("default", {
    // you can use undefined as first argument
    year: "numeric",
  });

  // let hrs_mins = date.toLocaleString('default', { hour: 'numeric', minute: 'numeric', hour12: true })
  let return_format = month + " " + day + ", " + year;

  return return_format;
};

const ConvertUtcToYear = (UTC_FormatDate: any) => {
  let date = new Date(UTC_FormatDate);

  const year = date.toLocaleDateString("default", {
    // you can use undefined as first argument
    year: "numeric",
  });

  return year;
};

const ConvertUtcToLocalReadableFullDate = (UTC_FormatDate: any) => {
  let date = new Date(UTC_FormatDate);
  const month = date.toLocaleString("default", { month: "short" });
  const day = date.toLocaleDateString("default", {
    // you can use undefined as first argument
    day: "2-digit",
  });
  const year = date.toLocaleDateString("default", {
    // you can use undefined as first argument
    year: "numeric",
  });

  let hrs_mins = date.toLocaleString("default", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    second: "numeric",
  });
  let return_format = month + " " + day + ", " + year + " " + hrs_mins;

  return return_format;
};

function UNIXToReadableFullDateTime(UNIX_timestamp: any) {
  var a = new Date(UNIX_timestamp);
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time =
    date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
  return time;
}

const UniteConversion = (unit_pref: any, value: any, unit_type: any) => {
  if (unit_pref === "Imperial") {
    if (unit_type === "temperature") {
      let fahrenheit: any = value * 1.8 + 32;

      return `${fahrenheit?.toFixed(1)} ${"\u00b0"} F`;
    }
    if (unit_type === "wind_speed") {
      let mi: any = value * 0.621371;
      return `${mi?.toFixed(1)} mph`;
    }

    if (unit_type === "ground_range") {
      let inchs: any = value / 2.54;
      return `${inchs?.toFixed(0)} inchs`;
    }
  } else {
    if (unit_type === "temperature") {
      return `${value} ${"\u00b0"} C`;
    }
    if (unit_type === "wind_speed") {
      return `${value} km/h`;
    }

    if (unit_type === "ground_range") {
      // let mi: any = value * 0.621371;
      return `${value} cm`;
    }
  }
};

const CreateUniqueArrayOperationTableAPI = (JSON_DATA: any) => {
  /* Your JSON data here */ const data = JSON_DATA;

  // Create an object to store unique values based on siteID
  const uniqueValues: any = {};
  data?.forEach((item: any) => {
    const siteID = item.siteID;
    if (!uniqueValues[siteID]) {
      // If the siteID is not in uniqueValues, add it with the current item
      uniqueValues[siteID] = {
        ...item,
        AlltotalLeaks: item.totalLeaks,
      };
    } else {
      // If the siteID is already in uniqueValues, update totalLeaks
      uniqueValues[siteID].AlltotalLeaks += item.totalLeaks;
    }
  });

  // Convert the uniqueValues object into an array and sort by createdOn
  const sortedUniqueArray = Object.values(uniqueValues).sort(
    (a: any, b: any) => {
      let a_sort: any = new Date(a.createdOn);
      let b_sort: any = new Date(b.createdOn);
      return b_sort - a_sort;
    }
  );
  return sortedUniqueArray;
  // The sortedUniqueArray now contains unique values sorted by createdOn
};

// Generate random color array start
function generateLowContrastHashColors(numColors: any) {
  const colors = [
    "#85c5e3",
    "#85a9e3",
    "#858de3",
    "#9985e3",
    "#b585e3",
    "#d285e3",
    "#e385d7",
    "#e385bb",
    "#e38785",
  ];
  const minLightness = 45; // Adjust as needed for your desired lightness
  const maxLightness = 50; // Adjust as needed for your desired lightness

  for (let i = 9; i < numColors; i++) {
    const lightness =
      Math.floor(Math.random() * (maxLightness - minLightness + 1)) +
      minLightness;
    const hue = Math.floor(Math.random() * 360); // Random hue value between 0 and 360
    const saturation = Math.floor(Math.random() * 31) + 30; // Adjust saturation as needed

    // Convert HSL color to hexadecimal color code
    const rgbColor = hslToRgb(hue / 360, saturation / 100, lightness / 100);
    const hexColor = rgbToHex(rgbColor);

    colors.push(hexColor);
  }

  return colors;
}

// Function to convert HSL color to RGB color
export function hslToRgb(h: any, s: any, l: any) {
  let r, g, b;

  if (s === 0) {
    r = g = b = l; // Achromatic
  } else {
    const hue2rgb = (p: any, q: any, t: any) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;

    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

// Function to convert RGB color to hexadecimal color code
function rgbToHex(rgb: any) {
  return `#${rgb
    .map((value: any) => value.toString(16).padStart(2, "0"))
    .join("")}`;
}

// Generate random color array end

function generateRandomNumber(min: any, max: any) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Convert UTC to
function UTCToPayloadDate(UTC_FormatDate: any) {
  let date: any = new Date(UTC_FormatDate);
  const month = date.toLocaleString("default", { month: "2-digit" });
  const day = date.toLocaleDateString("default", {
    // you can use undefined as first argument
    day: "2-digit",
  });
  const year = date.toLocaleDateString("default", {
    // you can use undefined as first argument
    year: "numeric",
  });
  return `${year}-${month}-${day}`;
}
// unique records start
function getUniqueRecordsByName(arr: any, temp_current_survey_date: any) {
  // console.log(arr);
  const uniqueNames: any = {}; // Initialize an object to store unique names
  const uniqueRecords: any = [];

  for (const record of arr) {
    const name = record.name;

    if (!uniqueNames[name]) {
      // If the name is not in uniqueNames, it's unique
      uniqueNames[name] = true; // Mark it as seen
      uniqueRecords.push(record); // Add the record to the uniqueRecords array
    } else {
      // If the name is already in uniqueNames, you can choose to do something here
      // For example, you can update an existing record or ignore the duplicate
      // In this example, we're ignoring the duplicate.
    }
  }

  return uniqueRecords;
}

// unique records end
const GetProper_Custom_Unique_records = async (arr: any, survey_date: any) => {
  return await new Promise((resolve, reject) => {
    let temp_current_survey_date: any = {};
    let temp_current_survey_date_readable: any =
      ConvertUtcToLocalReadable(survey_date);
    let final_array: any = arr;
    final_array = final_array.filter((element: any, index1: any) => {
      if (survey_date === element.code) {
        temp_current_survey_date = { name: element.name, code: element.code };
      }
      return temp_current_survey_date_readable !== element.name;
    });
    if (final_array.length === 0) {
      final_array.push(temp_current_survey_date);
    } else {
      final_array = getUniqueRecordsByName(final_array, temp_current_survey_date);
      final_array.push(temp_current_survey_date);
    }
    resolve(final_array);
  });
};

export function convertDateToTimestamp(dateString:any) {
  const parts = dateString.split('/');
  const month = parseInt(parts[0], 10) - 1; // Month is 0-indexed in JavaScript, so subtract 1
  const day = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);

  // Create a Date object
  const date = new Date(year, month, day);

  // Get the timestamp (in milliseconds)
  const timestamp = date.getTime();

  // Convert to seconds by dividing by 1000
  return timestamp / 1000;
}

export function convertUTCtoMMDDYYYY(utcDate:any) {
  // Create a new Date object from the UTC string
  const date = new Date(utcDate);

  // Get the components of the date
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1; // Month is zero-based, so add 1
  const day = date.getUTCDate();

  // Format the components as MM/DD/YYYY
  const formattedDate = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;

  return formattedDate;
}

export function convertToUTC(dateString:any) {
  // Parse the input date string manually
  // const parts = dateString.match(/(\w{3}) (\w{3}) (\d{2}) (\d{4}) (\d{2}):(\d{2}):(\d{2}) GMT([\+\-]\d{4})/);
  
  // if (!parts) {
  //   // Handle invalid date string
  //   return null;
  // }

  // const [, day, month, dayOfMonth, year, hours, minutes, seconds, timeZone] = parts;

  // Create a new Date object using the parsed values
  const date = new Date(dateString);
  
  // Return the UTC-formatted date string
  return date.toISOString();
}
export function capitalizeString(str:string) {
  return str.replace(/\b\w/g, function(char) {
      return char.toUpperCase();
  });
}
export function getMenuNameByMenu(str:string) {
  return str.replace(/-/g, ' ').replace(/\b\w/g, function(char) {
    return char.toUpperCase();
  });
}
export function isNotNullOrEmpty(value:any) {
  return value !== null && value !== undefined && value !== "";
}

export const IsNullOrEmpty = (obj: any) => {
  if (
    !obj ||
    (typeof obj === "object" &&
      Object.keys(obj).length === 0 &&
      !Array.isArray(obj)) ||
    (Array.isArray(obj) && obj && !obj.length)
  ) {
    return true;
  } else {
    return false;
  }
};
export const getTimzeZoneUI = (tzStr?: string) => {
  let tz = "";
  if (tzStr && tzStr != null) {
    tz = moment.tz(tzStr).format("z");
  } else {
    tz = moment.tz("America/Chicago").format("z"); // Default value will be CDT
  }
  return tz;
  // Output :  CDT, CST, IST...
};
export const getDateTimeTzByTimeZone = (time: string, tzStr?: string) => {
  let dateTime = "";
  if (time && time != null && tzStr && tzStr != null) {
    dateTime = moment.tz(time, tzStr).format("MM-DD-YYYY hh:mmA");
  }else if (time && time != null && !tzStr && tzStr == null) {
    dateTime = moment.tz(time, "America/Chicago").format("MM-DD-YYYY hh:mmA");
  } else {
    dateTime = moment.tz("America/Chicago").format("MM-DD-YYYY hh:mmA");
  }
  return `${dateTime} ${getTimzeZoneUI(tzStr)}`;
};
export const getDateByTimeZone = (date: string, tzStr?: string) => {
  let dateTime = "";
  if (date && date != null && tzStr && tzStr != null) {
    dateTime = moment.tz(date, tzStr).format("MM-DD-YYYY");
  }else if (date && date != null && !tzStr && tzStr == null) {
    dateTime = moment.tz(date, "America/Chicago").format("MM-DD-YYYY");
  } else {
    dateTime = moment.tz("America/Chicago").format("MM-DD-YYYY");
  }
  return `${dateTime}`;
};
export const getTimzeZoneForAPI = (tzStr: string) => {
  let tz = "";
  if (tzStr && tzStr != null) {
    tz = tzStr;
  } else {
    tz = moment.tz.guess();
  }
  return tz;
}; 
export const getEmissionMetric = (uom: string) => {
  let mtr = "";
  if (uom === "Imperial") {
    mtr = "MCF/day";
  } else {
    mtr = "kg/hr";
  }
  return mtr;
};
export const convertDateToCustomFormat = (isoDateString: moment.MomentInput) => {
  // DateStr should come as UTC format from API then only this will work
  return moment(isoDateString).utc().format('MM-DD-YYYY hh:mm A') + ' UTC';
};
export const getOnlyDateMMDDYY = (DateStr: string) => {
  // DateStr should come as UTC format from API then only this will work
  return moment(DateStr).utc().format('MM-DD-YYYY'); 
};
export const convertStringToNumber = (NumberString: any) => {
  // Validate the data, null, undefined,empty
  // Convert string number to Float fixed with 7 digit
  if(NumberString && NumberString != null && NumberString !== undefined && NumberString !==""){
    return parseInt(NumberString)
  }
  return 0;
};
export const convertStringToFloat = (NumberString: string, decimalFixed:number) => {
  // Validate the data, null, undefined, empty
  // Convert string number to Float fixed with 7 digit
  if(NumberString && NumberString != null && NumberString !== undefined && NumberString !==""){
    if(decimalFixed){
      return parseFloat(NumberString).toFixed(decimalFixed)  
    }
    return parseFloat(NumberString)
  }
  return 0;
};
export const convertStringToFloatForKLVMedia = (NumberString: string, decimalFixed:number) => {
  // Validate the data, null, undefined,empty
  // Convert string number to Float fixed with 7 digit
  if(NumberString && NumberString != null && NumberString !== undefined && NumberString !==""){
    if(decimalFixed){
      return parseFloat(NumberString).toFixed(decimalFixed)  
    }
    return parseFloat(NumberString)
  }
  return "-";
};

// Helper function to calculate the new position with a 3-meter offset
export const getLatlngOffsetPosition = (lat: number, lng: number, offset: number, index: number) => {
  const latOffset = offset / 111320; // Convert meters to degrees latitude
  const lngOffset = offset / (111320 * Math.cos(lat * (Math.PI / 180))); // Convert meters to degrees longitude

  // To create a 3-meter gap, we move markers in small directions
  const direction = index % 4;
  let newLat = lat;
  let newLng = lng;

  // Offset in a circular pattern (e.g., move markers in 4 directions around the center)
  switch (direction) {
    case 0: // Move to the right
      newLat = lat + latOffset;
      newLng = lng + lngOffset;
      break;
    case 1: // Move down
      newLat = lat - latOffset;
      newLng = lng + lngOffset;
      break;
    case 2: // Move to the left
      newLat = lat - latOffset;
      newLng = lng - lngOffset;
      break;
    case 3: // Move up
      newLat = lat + latOffset;
      newLng = lng - lngOffset;
      break;
  }

  return { lat: newLat, lng: newLng };
};

const Helpers = {
  ConsoleLog,
  ConsoleLogError,
  ConvertUtcToLocalReadable,
  ConvertUtcToLocalReadableFullDate,
  UNIXToReadableFullDateTime,
  ConvertUtcToYear,
  UniteConversion,
  CreateUniqueArrayOperationTableAPI,
  generateLowContrastHashColors,
  generateRandomNumber,
  UTCToPayloadDate,
  GetProper_Custom_Unique_records,
  convertDateToTimestamp,
  convertUTCtoMMDDYYYY,
  convertToUTC,
  capitalizeString,
  isNotNullOrEmpty,
  getTimzeZoneUI,
  getDateTimeTzByTimeZone,
  getTimzeZoneForAPI,
  getEmissionMetric,
  getDateByTimeZone,
  convertDateToCustomFormat,
  getMenuNameByMenu,
  convertStringToNumber,
  convertStringToFloat,
  convertStringToFloatForKLVMedia,
  getLatlngOffsetPosition
};

export default Helpers;
